import dictionaryService from '@/core/dictionary/dictionary.service';
import viewportEventsService from '@/core/responsive/viewport/viewport-events.service';
import { ShareNavigator } from '@/types/global';

export function useSharing(): ISharingComposable {
    const nativeIsSupported: boolean = navigator && !!(navigator as ShareNavigator).share;

    const pinterestShareLink = (shareUrl: string, media: string) => {
        return `//pinterest.com/pin/create/button/?url=${encodeURIComponent(shareUrl)}&media=${encodeURIComponent(media)}`;
    };

    const emailShareLink = (shareUrl: string, subject: string, bodyText: string) => {
        return `mailto:?subject=${subject}&body=${dictionaryService.format(bodyText, [encodeURIComponent(shareUrl)])}`;
    };

    const openFacebookShareWindow = (shareUrl: string) => {
        const dialogueWidth = 800;
        const dialogueHeight = 440;

        const browserWidth = viewportEventsService.viewport.width;
        const browserHeight = viewportEventsService.viewport.height;

        const handleLeftPositionOnMultiMonitorSystem = window.screenX;

        const left = (browserWidth / 2) - (dialogueWidth / 2) + handleLeftPositionOnMultiMonitorSystem;
        const top = (browserHeight - dialogueHeight) / 2;

        const newWindowFeatures = `width=${dialogueWidth}, height =${dialogueHeight}, top=${top}, left=${left}`;

        window.open(`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(shareUrl)}`,
            '_blank',
            newWindowFeatures);
    };

    return {
        nativeIsSupported,
        pinterestShareLink,
        emailShareLink,
        openFacebookShareWindow,
    };
}

export interface ISharingComposable {
    nativeIsSupported: boolean;
    pinterestShareLink(shareUrl: string, media: string);
    emailShareLink(shareUrl: string, subject: string, bodyText: string);
    openFacebookShareWindow(shareUrl: string);
}
